<template>
  <div>
    <h5 class="mb-3">{{ $t('Ayuda') }}</h5>
    <p>{{ $t('Aquí encontrará respuesta a las dudas que te puedan surgir') }}.</p>

    <h6 class="mt-4">{{ $t('Listas de productos favoritos') }}</h6>

    <div class="accordion_area mt-3">
      <div id="accordion" class="card__accordion">
        <div v-for=" (item, index) in questions " :key="index" class="card card_dipult">
          <div class="card-header card_accor" :id="'heading'+index">
            <button class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">
              {{ item.title }}
              <i class="fa fa-plus"></i>
              <i class="fa fa-minus"></i>
            </button>
          </div>
          <div :id="'collapse'+index" class="collapse" :aria-labelledby="'heading'+index" data-parent="#accordion">
            <div class="card-body">
              <img v-if=" item.gif " :src=" getBaseUrl + 'productos/files/help/' + item.gif +'.gif' " alt="">
              <div 
                v-if=" item.text "
                v-html=" item.text "
              >             
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Ayuda": "Ayuda",
      "Aquí encontrará respuesta a las dudas que te puedan surgir": "Aquí encontrará respuesta a las dudas que te puedan surgir",
      "Listas de productos favoritos": "Listas de productos favoritos",
      "¿Qué son las listas de favoritos?": "¿Qué son las listas de favoritos?",
      "Son listas en las que puedes guardar tus productos que compras muy a menudo para luego añadirlos de manera rápida al carrito de compra.": "Son listas en las que puedes guardar tus productos que compras muy a menudo para luego añadirlos de manera rápida al carrito de compra.",
      "¿Cómo funcionan las listas de favoritos?": "¿Cómo funcionan las listas de favoritos?",
      "funcionamiento listas": "¿Realizas compras regulares y necesitas seleccionar cada vez todos los productos uno por uno? A partir de ahora te lo ponemos mucho más fácil con las listas de productos favoritos. Crea tu lista de favoritos y selecciona cada producto especificando la cantidad. En la siguiente compra con un solo click podrás añadir todos los productos al carrito de compra.",
      "¿Cómo crear una lista de favoritos?": "¿Cómo crear una lista de favoritos?",
      "¿Cómo modificar el nombre de una lista de favoritos?": "¿Cómo modificar el nombre de una lista de favoritos?",
      "¿Cómo añadir un producto a una lista de favoritos?": "¿Cómo añadir un producto a una lista de favoritos?",
      "¿Cómo modificar un producto de una lista de favoritos?": "¿Cómo modificar un producto de una lista de favoritos?",
      "¿Cómo añadir una lista de productos favoritos al carrito de compra?": "¿Cómo añadir una lista de productos favoritos al carrito de compra?",
      "¿Cómo añadir un único producto de una lista de favoritos al carrito de compra?": "¿Cómo añadir un único producto de una lista de favoritos al carrito de compra?",
      "¿Cómo guardar el carrito de compra en una lista de favoritos?": "¿Cómo guardar el carrito de compra en una lista de favoritos?"
    },
    "en": {
      "Ayuda": "Help",
      "Aquí encontrará respuesta a las dudas que te puedan surgir": "Here you will find an answer to any doubts",
      "Listas de productos favoritos": "Favorite product lists",
      "¿Qué son las listas de favoritos?": "What are the favorites lists?",
      "Son listas en las que puedes guardar tus productos que compras muy a menudo para luego añadirlos de manera rápida al carrito de compra.": "They are lists in which you can save your products that you buy very often and then quickly add them to the shopping cart.",
      "¿Cómo funcionan las listas de favoritos?": "How do the favorites lists work?",
      "funcionamiento listas": "Do you make regular purchases and need to select all the products one by one each time? From now on we make it much easier for you with the lists of favorite products. Create your list of favorites and select each product specifying the quantity. In the next purchase with a single click you can add all the products to the shopping cart.",
      "¿Cómo crear una lista de favoritos?": "How to create a favorites list?",
      "¿Cómo modificar el nombre de una lista de favoritos?": "How to modify the name of a favorites list?",
      "¿Cómo añadir un producto a una lista de favoritos?": "How to add a product to a favorites list?",
      "¿Cómo modificar un producto de una lista de favoritos?": "How to modify a product from a favorites list?",
      "¿Cómo añadir una lista de productos favoritos al carrito de compra?": "How to add a list of favorite products to the shopping cart?",
      "¿Cómo añadir un único producto de una lista de favoritos al carrito de compra?": "How to add a single product from a favorites list to the shopping cart?",
      "¿Cómo guardar el carrito de compra en una lista de favoritos?": "How to save the shopping cart to a favorites list?"
    }
  }
</i18n>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        questions:[
          {
            title: this.$t('¿Qué son las listas de favoritos?'),
            gif: '',
            text: this.$t('Son listas en las que puedes guardar tus productos que compras muy a menudo para luego añadirlos de manera rápida al carrito de compra.')
          },
          {
            title: this.$t('¿Cómo funcionan las listas de favoritos?'),
            gif: '',
            text: '<p>' + this.$t('funcionamiento listas') + '</p>'
          },
          {
            title: this.$t('¿Cómo crear una lista de favoritos?'),
            gif: 'favlist-crear',
            text: ''
          },
          {
            title: this.$t('¿Cómo modificar el nombre de una lista de favoritos?'),
            gif: 'favlist-modificar',
            text: ''
          },
          {
            title: this.$t('¿Cómo añadir un producto a una lista de favoritos?'),
            gif: 'favlist-anadir-producto',
            text: ''
          },
          {
            title: this.$t('¿Cómo modificar un producto de una lista de favoritos?'),
            gif: 'favlist-modificar-producto',
            text: ''
          },
          {
            title: this.$t('¿Cómo añadir una lista de productos favoritos al carrito de compra?'),
            gif: 'favlist-lista-a-carrito',
            text: ''
          },
          {
            title: this.$t('¿Cómo añadir un único producto de una lista de favoritos al carrito de compra?'),
            gif: 'favlist-producto-a-carrito',
            text: ''
          },
          {
            title: this.$t('¿Cómo guardar el carrito de compra en una lista de favoritos?'),
            gif: 'favlist-carrito-a-lista',
            text: ''
          },
        ]
      }
    },
    mounted() {
    },
    computed: {	
      ...mapGetters( ['getBaseUrl'])
    },
  }
</script>
